import React, { Component } from 'react'
import PropTypes from 'prop-types'
import ReactTransitionGroup from 'react-transition-group/TransitionGroup'
import SlideInChild from './SlideInChild'

class SlideIn extends Component {
  static propTypes = {
    childStyle: PropTypes.object,
    children: PropTypes.node,
    direction: PropTypes.oneOf(['left', 'right', 'up', 'down']),
    enterDelay: PropTypes.number,
    style: PropTypes.object
  }

  static defaultProps = {
    enterDelay: 0,
    direction: 'left'
  }

  static contextTypes = {
    muiTheme: PropTypes.object.isRequired
  }

  getLeaveDirection = () => {
    return this.props.direction
  }

  render() {
    const {
      enterDelay,
      children,
      childStyle,
      direction,
      style,
      ...other
    } = this.props

    const { prepareStyles } = this.context.muiTheme

    const mergedRootStyles = Object.assign(
      {},
      {
        position: 'relative',
        overflow: 'hidden',
        height: '100%'
      },
      style
    )

    const newChildren = React.Children.map(
      children,
      child => {
        return (
          <SlideInChild
            key={child.key}
            direction={direction}
            enterDelay={enterDelay}
            getLeaveDirection={this.getLeaveDirection}
            style={childStyle}
          >
            {child}
          </SlideInChild>
        )
      },
      this
    )

    return (
      <ReactTransitionGroup
        {...other}
        style={prepareStyles(mergedRootStyles)}
        component="div"
      >
        {newChildren}
      </ReactTransitionGroup>
    )
  }
}

export default SlideIn



// WEBPACK FOOTER //
// ./src/components/common/calendar/SlideIn.js